import React from 'react';

import FlightsDetails from 'components/FlightsDetails';
import { TravelDetails } from 'models/travelDetails';
import CancellationPolicies from 'screens/components/FlightDetails/components/CancellationPolicies';

import Passenger from './components/Passenger';
import { Container, Padding } from './styles';

interface Props {
  data: TravelDetails;
}

const Flights = ({ data }: Props) => (
  <Container>
    <FlightsDetails sectors={data.flightSectors || []} />
    <Padding>
      <CancellationPolicies policies={data.air?.airFareConditions || []} />
      <Passenger requester={data.requester} />
    </Padding>
  </Container>
);

export default Flights;
